import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(3),
      width: '100%',
      height: theme.spacing(16),
    },
  },
  text: {
    padding: theme.spacing(5),
    textAlign: 'center'
  },
  cardChart: {
    marginTop: theme.spacing(2),
    minHeight: '400px'
  },
  cardBarChart: {
    marginLeft: theme.spacing(1),
  },
  chartContainer: {
    position: 'relative',
    height: '200px',
  },


  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  checkbox: {
  },
  cardRodadaAndGrafico: {
    maxHeight: 350,
    minHeight: 350,
    marginBottom: 10
  }
}));
export {useStyles}

